module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-page"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择加油站"
    },
    model: {
      value: (_vm.oilStation),
      callback: function($$v) {
        _vm.oilStation = $$v
      },
      expression: "oilStation"
    }
  }, _vm._l((_vm.predictionGasList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-tables"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "进销存数据"
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.showData,
      "rowDef": true,
      "ths": _vm.jxcThs
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-table-2 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "预测结果"
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.showData,
      "rowDef": true,
      "ths": _vm.jxcThs2
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-2-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单 ' + _vm.preDay,
      "actions": _vm.actions
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.preDayData,
      "ths": _vm.jxcThs3,
      "scroll_table": true
    }
  })], 1), _vm._v(" "), (_vm.showNote) ? _c('div', {
    staticClass: "content-2-note"
  }, [_vm._v("\n      日销量预测分析步骤："), _c('br'), _vm._v("\n      1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。"), _c('br'), _vm._v("\n      2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA"), _c('br'), _vm._v("\n      3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。"), _c('br'), _vm._v("\n      断货时间点预测:"), _c('br'), _vm._v("\n      我们针对5个加油站(昭通昭阳元宝山加油站，昭通昭阳头道沟加油站，昆明安宁丰营加油站，昆明西山照壁加油站，玉溪易门蒲贝加油站)，利用其20天的历史数据，运用上述分析方法，预测出之后三天内的订单情况。"), _c('br'), _vm._v("\n      订单紧急程度划分说明："), _c('br'), _vm._v("\n      1.可配送订单：24小时<断货时间点≤48小时；"), _c('br'), _vm._v("\n      1.紧急订单：断货时间点≤24小时。\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-2-btn"
  }, [_c('div', {
    staticClass: "btn-top-jiao"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showNote = !_vm.showNote
      }
    }
  }, [_vm._v("预"), _c('br'), _vm._v("测"), _c('br'), _vm._v("分"), _c('br'), _vm._v("析"), _c('br'), _vm._v("方"), _c('br'), _vm._v("法")]), _vm._v(" "), _c('div', {
    staticClass: "btn-bottom-jiao"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-3-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '小罐多销加油站'
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.dxData,
      "ths": _vm.jxcThs4,
      "scroll_table": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-763e4d46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/prediction.vue
// module id = 1000
// module chunks = 1